export const features = {
  DESKTOP_POST_ADD_TO_CART: 'desktop_post_add_to_cart_behavior'
};
export const featureKeys = Object.values(features);
const defaultPostAddToCartConfig = {
  hideFBTHideRelatedTopic: false,
  showFBTHideRelatedTopic: false
};
export const getPostAddToCartConfig = featureVariantAssignmentsConfig => {
  const config = featureVariantAssignmentsConfig !== null && featureVariantAssignmentsConfig !== void 0 ? featureVariantAssignmentsConfig : defaultPostAddToCartConfig;
  if (config.hideFBTHideRelatedTopic) {
    return {
      isSingleSelectableUnit: true,
      shouldRenderBundleUnit: false,
      showRelatedLabelsList: false
    };
  }
  if (config.showFBTHideRelatedTopic) {
    return {
      isSingleSelectableUnit: true,
      shouldRenderBundleUnit: true,
      showRelatedLabelsList: false
    };
  }
  return {
    isSingleSelectableUnit: false,
    shouldRenderBundleUnit: true,
    showRelatedLabelsList: true
  };
};
//# sourceMappingURL=utils.js.map